import List from './List';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'statements',
  inputShow: gql`
    query statements($input: StatementQueryInput) {
      statements(input: $input) {
        id
        __typename
      }
    }
  `,
  list: List,
  edit: Edit,
  show: Show,
  options: {
    group: 'Billing',
    label: 'Statements',
  },
};
